// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"293":"39e15a4a","360":"52f068d8","474":"f7ae53a1"}[chunkId] + ".chunk.css";
};